"use client"

import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { Search, Filter } from "lucide-react"
import type { CallsFilters as CallsFiltersType } from "@/hooks/use-calls"
import { useTranslations } from "next-intl"


interface CallsFiltersProps {
  filters: CallsFiltersType
  totalCount: number
  showArchived: boolean
  onSearchChange: (search: string) => void
  onStatusChange: (status: string) => void
  onClearFilters: () => void
}

export function CallsFilters({
  filters,
  totalCount,
  showArchived,
  onSearchChange,
  onStatusChange,
  onClearFilters,
}: CallsFiltersProps) {
  const tUi = useTranslations("Calls.CallsCallsFilters")
  const tCommonUi = useTranslations("Common")

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex-1 min-w-[250px] max-w-md">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
            <Input
              placeholder={tUi("searchByPhoneAgentName")}
              value={filters.search}
              onChange={(e) => onSearchChange(e.target.value)}
              className="pl-10"
            />
          </div>
        </div>

        <div className="w-[150px]">
          <Select value={filters.status} onValueChange={onStatusChange}>
            <SelectTrigger>
              <SelectValue placeholder={tUi("status")} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all"><span key={tUi("allStatus")}>{tUi("allStatus")}</span></SelectItem>
              <SelectItem value="done"><span key={tCommonUi("completed")}>{tCommonUi("completed")}</span></SelectItem>
              <SelectItem value="failed"><span key={tUi("failed")}>{tUi("failed")}</span></SelectItem>
              <SelectItem value="in_progress"><span key={tUi("inProgress")}>{tUi("inProgress")}</span></SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={onClearFilters}>
            <Filter className="w-4 h-4 mr-1" />
            <span><span key={tUi("clear")}>{tUi("clear")}</span></span>
          </Button>
          <div className="text-sm text-gray-500 whitespace-nowrap">
            {totalCount} <span key={showArchived ? tUi("archived") : tUi("calls")}>{showArchived ? tUi("archived") : tUi("calls")}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
